import { useContext, useState } from 'react';
import InputMask from 'react-input-mask';
import './stylesDisparo.css';
import api from '../../../../services/api';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AlertMessage from '../../../Alert';
import { CadastroContext } from '../../../../contexts/CadastroContext';
import isNotNullOrEmpty from '../../../../utils/isNotNullOrEmpty';
import { Load } from '../../../Load';

const AsoDisparoSms = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { cadastro, handleCadastroChange } = useContext(CadastroContext);
    const [buttonEnabled, setButtonEnabled] = useState<boolean>(false);
    const [alert, setAlert] = useState<{ show: boolean; message: string; variant: string }>({ show: false, message: "", variant: "success" });
    const [telefoneInput, setTelefoneInput] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { dbName } = useParams();

    const handleInput = (event: { target: { value: any; }; }) => {
        const value = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters
        setAlert({ show: false, message: '', variant: 'success' }); // Reset alert message when typing
        setTelefoneInput(value);
        setButtonEnabled(value.length >= 11); // Enable button only if phone number length is valid
    };

    const handleBlur = () => {
        if (telefoneInput.length < 11) {
            setAlert({ show: true, message: 'Insira um número de telefone válido!', variant: "danger" });
        }
    };

    const handleClick = async () => {
        try {
            if (telefoneInput.length >= 11) {
                setIsLoading(true);
                const corpo = { telefoneInput, dbName };
                await api.post('/recebe-disparo-sms', corpo);
                cadastro.telefone = telefoneInput;
                handleCadastroChange(cadastro);
                setIsLoading(false);
                if (location.pathname === `/aso/registro/disparo-sms-aso/${dbName}`) {
                    return navigate(`/aso/registro/disparo-sms-token-aso/${telefoneInput}/${dbName}`);
                } else {
                    return navigate(`/aso/registro/disparo-sms-token/${telefoneInput}/${dbName}`);
                }
            } else {
                setAlert({ show: true, message: 'Insira um número de telefone válido!', variant: "danger" });
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Erro ao processar a requisição:', error);
            setAlert({ show: true, message: 'Ocorreu um erro ao processar sua solicitação. Por favor, tente novamente mais tarde.', variant: 'danger' });
        }
    };

    const handleVoltar = () => {
        if (cadastro.isEmpresa) {
            return navigate(`/aso/registro/validar-info-empresa/${cadastro.idConsulta}`);
        } else if (cadastro.idConsulta) {
            return navigate(`/aso/registro/validar-info/${cadastro.idConsulta}/${dbName}`);
        }
    };

    return (
        <>
            <Load isLoading={isLoading} />
            {!isLoading && (
                <div className="generic-layout__container-disparo">
                    <div className='layout-mp__top-container-disparo'>
                        <div className='layout-mp__title-disparo'>
                            <div className='layout-mp__title_text-disparo'>Continue do seu celular.</div>
                        </div>
                        <div className='layout-mp__main-container-disparo'>
                            <div className='phone-landing__container-disparo'>
                                <div className='continue_phone_landing__elements-disparo'>
                                    <div>
                                        <div className='continue_phone_landing__title-disparo'>Continue do seu celular.</div>
                                        <div className='continue_phone_landing__text-disparo'></div>
                                    </div>
                                    <div>
                                        <form>
                                            <div className='phone-landing__input-disparo'>
                                                <span className='phone-landing__placeholder-disparo'>+55</span>
                                                <input type="hidden" name="_csrf" />
                                                <label className='ui-input-text-disparo'>
                                                    <InputMask
                                                        mask="(99) 99999-9999"
                                                        value={telefoneInput}
                                                        onChange={handleInput}
                                                        onBlur={handleBlur}
                                                    >
                                                        {(inputProps: any) => <input {...inputProps} name="phone_number" className='ui-input-text__input-disparo' />}
                                                    </InputMask>
                                                    <div className='ui-input-text__status-bar-disparo'></div>
                                                    <div className='ui-input-text__hint-disparo'>41 9 1234-5678</div>
                                                </label>
                                            </div>
                                        </form>
                                        <div className='phone-landing__actions-disparo'>
                                            <div className='component__actions_horizontal-disparo component__actions_mp_desktop-disparo'>
                                                <span>
                                                    <button type="button" className={'andes-button-disparo andes-button--large-disparo andes-button--loud-disparo'}
                                                        disabled={!buttonEnabled} onClick={handleClick}>
                                                        <span className='andes-button__content-disparo'>
                                                            <span className='andes-button__text-disparo'>Enviar</span>
                                                        </span>
                                                    </button>
                                                </span>
                                                <span>
                                                    <button className='andes-button-disparo andes-button--large-disparo andes-button--transparent-disparo andes-button-disparo' onClick={handleVoltar}>
                                                        <span className='andes-button__content-disparo'>
                                                            <span className='andes-button__text-disparo'>Voltar</span>
                                                        </span>
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='continue_phone_landing__image-container-disparo'>
                                    <img className="continue_phone_landing__background-image-disparo" src="https://http2.mlstatic.com/storage/identity-validation-mobile-api/images/web/MP/texture_desktop.png" />
                                    <img className="continue_phone_landing__image-disparo" src="https://http2.mlstatic.com/storage/identity-validation-mobile-api/images/web/MP/empty-phone.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <AlertMessage
                        show={alert.show}
                        message={alert.message}
                        variant={alert.variant}
                        onClose={() => setAlert({ ...alert, show: false })}
                    />
                </div>
            )}
        </>
    );
}

export default AsoDisparoSms;